module.exports = "/_next/static/images/icon_weather_14-ca39f90e7dcdb7138d55b7d13690af66.svg";